module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "fixed": "",
      "dark": "",
      "color": "error"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "text-center"
  }, [_vm._v("仁翔药业抽奖平台")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md4": ""
    }
  }, [_c('v-form', {
    ref: "ruleForm2",
    staticClass: "login-form"
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.rules2.account,
      "prepend-icon": "person",
      "name": "login",
      "label": "请输入您的仁翔药购网登陆账号",
      "type": "text"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  }), _vm._v(" "), (false) ? _c('v-text-field', {
    attrs: {
      "rules": _vm.rules2.checkPass,
      "id": "password",
      "prepend-icon": "lock",
      "name": "password",
      "readonly": "",
      "label": "密码",
      "type": "password"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("登陆仁翔药购网APP，选择界面右下角\"我的\"，查看左上角即为您本人账号")]), _vm._v(" "), _c('p', [_vm._v("或登陆仁翔药购网网页版，选择\"我的药购网即为您本人账号\"")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text login",
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.handleSubmit2
    }
  }, [_vm._v("登陆")]), _vm._v(" "), _c('my-snack-bar', {
    attrs: {
      "snackbar-content": _vm.snackbarOption.text,
      "snackbar-show": _vm.snackbarOption.show,
      "snackbar-hint-type": _vm.snackbarOption.hintType
    },
    on: {
      "close": _vm.handleSnackbarClose
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0795322e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/userLogin.vue
// module id = 600
// module chunks = 1